







































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Rodape extends Vue {
  // ENVIAR PARA O TOPO DA PÁGINA
  scrollToTop() {
    window.scrollTo(0, 0);
  }
}
